import {
  Button,
  createStyles,
  ListSubheader, makeStyles, Theme
} from '@material-ui/core';
import LogoTopLab from 'components/LogoTopLab/LogoTopLab';
import PagesContext from 'components/Pages/PagesContext';
import React, { useContext } from 'react';

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        border: 'none',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: theme.spacing(7),
      },
      brandButton: {
      },
      brand: {
        fontSize: theme.spacing(4)
      }
    }),
);

interface Props {
  toClose: () => void;
}

const LeftMenuSubHeader = ({
  toClose,
}: Props) => {
  const classes = useStyles();
  const {toHome} = useContext(PagesContext);

  return (
    <ListSubheader
      component="button"
      className={classes.root}
    >
      <Button
        className={classes.brandButton}
        onClick={() => {
          toClose();
          toHome();
        }}
      >
        <LogoTopLab
          className={classes.brand}
        />
      </Button>
    </ListSubheader>
  )
}

export default LeftMenuSubHeader;